/**
 * "Review" — the full game review (`Screens/ChessAnalysis`), the result card's
 * own button in the rail. Same condition as `ResultOverlay`'s `canReview`: my
 * finished game, with a uuid, that was not aborted.
 */
import {useShallow} from 'zustand/react/shallow';

import {useLiveGame} from '@/Store/liveGameStore';

import {openReview} from '../useGameActions';
import {selectActionGate} from '../gates';

export type ReviewActionModel = {
  label: string;
  hint: string;
  disabled: boolean;
  onPress: () => void;
};

export function useReviewActionModel(): ReviewActionModel {
  const gate = useLiveGame(useShallow(selectActionGate));
  const disabled = gate.watching || !gate.gameUuid || gate.aborted;

  return {
    label: 'Review',
    hint: disabled
      ? 'The full review opens when the game is over'
      : 'Open the full game review',
    disabled,
    onPress: openReview,
  };
}

export default useReviewActionModel;
